import { render } from "./Zagran.vue?vue&type=template&id=1d4b1958"
import script from "./Zagran.vue?vue&type=script&lang=js"
export * from "./Zagran.vue?vue&type=script&lang=js"

import exportComponent from "/builds/vei/portal/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__